import { ChangeDetectionStrategy, Component, ContentChildren, Input, QueryList, TemplateRef, AfterContentInit } from '@angular/core';
import { NxTemplateDirective } from '../../directives/nx-template.directive';


@Component({
  // tslint:disable-next-line:component-selector
  selector: "div[empty-box], nx-empty-box",
  templateUrl: "empty-box.html",
  host: {
    'class': 'nx-element flex flex-col'
  },
  styleUrls: ["./empty-box.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyBoxComponent implements AfterContentInit {

  /**
   * indicates, if the context menu of the action button is visible
   */
  public menuVisible = false;

  /**
   * All templates that are inside the box tag in the parent component
   */
  @ContentChildren(NxTemplateDirective) templates!: QueryList<NxTemplateDirective>;

  /**
   * The default class of the label element
   */
  public labelDefaultClass = 'text-base text-[#848488] font-light px-5 py-2 bg-white flex items-center justify-center h-12 min-w-[280px]';
  
  /**
   * Overwrites the default class of the label element
   */
  @Input() labelOverwriteClass: string | undefined;

  /**
   * Classes that sould be added to the default class of the label element
   */
  @Input() labelAdditionalClass: string | undefined;

  /**
   * The label of the box
   */
  @Input() label: string;

  /**
   * The template for the label of the box
   */
  public labelTemplate: TemplateRef<any> | undefined;
  
  constructor(
  ) {
  }

  /**
   * Walks through all templates and assigns them to the corresponding variables
   */
  ngAfterContentInit() {
    this.templates.forEach((item) => {
        switch (item.getType()) {
            case 'label':
                this.labelTemplate = item.template;
                break;
        }
    });
  }

  /**
   * Method return the class attribute for the label element
   * 
   * @returns string - the class of the label element
   */
  getLabelClass(): string {
    // if we have an overwrite, no merging, just return the overwrite
    if(this.labelOverwriteClass){
      return this.labelOverwriteClass;
    }
    let labelClass = this.labelDefaultClass;
    if(this.labelAdditionalClass){
      labelClass += ' ' + this.labelAdditionalClass;
    }
    return labelClass;
  }
  
}
